module.exports = __webpack_public_path__ + "static/eit-20e907e352a2a018f541865c377b261a.png";